/**
 * Lightweight IP localStorage helpers with no heavy dependencies.
 *
 * Kept separate from `ip.utils.tsx` so form/modal chunks that only need
 * `fetchIpInfoData` / `getIpJSONData` do not also pull `countries.ts`
 * (which is only required by `fetchAWSHeadersCountryCode`).
 */

export const fetchIpInfoData = async () => {
  const ipInfoData = JSON.parse(localStorage.getItem("ipDataStore_main"));
  try {
    if (ipInfoData?.ip) {
      return ipInfoData;
    }
    const data = await fetch("https://ipinfo.io/json?token=6b10d7bf80f030");
    const jsonData = await data.json();

    let orgList = jsonData?.org?.split(" ") || [];

    ipInfoData.ip = jsonData?.ip || "";
    ipInfoData.connection.asn = orgList.shift() || "";
    ipInfoData.connection.isp = orgList.join(" ") || "";

    if (!ipInfoData?.city) {
      ipInfoData.city = jsonData?.city;
    }

    if (!ipInfoData?.region_name) {
      ipInfoData.region_name = jsonData?.region;
    }

    if (ipInfoData?.country_code == "IN") {
      ipInfoData.zip = jsonData?.postal;
    }

    localStorage.setItem("ipInfoResponse", JSON.stringify(jsonData));

    localStorage.setItem("ipDataStore_main", JSON.stringify(ipInfoData));

    return ipInfoData;
  } catch (e) {
    return ipInfoData;
  }
};

export const getIpJSONData = (city?: string) => {
  const ipInfoData =
    JSON.parse(localStorage.getItem("ipDataStore_main")) || {};

  const ipInfoResponse =
    JSON.parse(localStorage.getItem("ipInfoResponse")) || {};
  const cloudfrontLog =
    JSON.parse(localStorage.getItem("cloudfrontLog")) || {};
  const data = { ...ipInfoData };
  const ipInfoDataResponse = { ...ipInfoResponse };

  // ip: CloudFront (x-forwarded-for, via /api/country-code) first, ipinfo.io fallback.
  data.ip = cloudfrontLog?.ip || ipInfoData?.ip || ipInfoResponse?.ip || "";

  // CloudFront geo headers first, ipinfo.io as fallback if CloudFront data is missing.
  data.city = cloudfrontLog?.city || data.city || "";
  data.country_code = cloudfrontLog?.countryCode || data.country_code || "";
  data.region_name = cloudfrontLog?.regionName || data.region_name || "";
  data.zip = cloudfrontLog?.postalCode || data.zip || "";

  if (city) {
    data.city = city;
    data.region = "Uttar Pradesh";
    data.region_name = "Uttar Pradesh";
    ipInfoDataResponse.city = city;
    ipInfoDataResponse.region = "Uttar Pradesh";
    ipInfoDataResponse.region_name = "Uttar Pradesh";
  }

  return {
    ...data,
    ipInfoDataResponse,
    cloudfrontLog,
  };
};
